import { useClickOutside } from '@/shared/hooks/use-click-outside';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useRef } from 'react';
import { ExpandedContextProvider } from './context/expanded-context.provider';
import styles from './expanded.module.css';
import { ExpandedProps } from './expanded.props';
import { useExpandedContext } from './hooks/use-expanded-context';

const VARIANTS = {
	hidden: {
		height: 0,
		opacity: 0,
		pointerEvents: 'none',
	},
	visible: {
		opacity: 1,
		height: 'auto',
		pointerEvents: 'all',
	},
} as const;

export const Expanded = (props: ExpandedProps) => {
	return (
		<ExpandedContextProvider>
			<ExpandedContent {...props} />
		</ExpandedContextProvider>
	);
};

const ExpandedContent = ({ triggerContent, content, classNames }: ExpandedProps) => {
	const { isOpen, setIsOpen } = useExpandedContext();
	const wrapperRef = useRef<HTMLDivElement>(null);

	useClickOutside(wrapperRef, () => setIsOpen(false));

	return (
		<div className={clsx(styles.wrapper, classNames?.wrapper)} ref={wrapperRef}>
			<div
				className={clsx(styles.trigger, classNames?.trigger)}
				onClick={() => setIsOpen(true)}
			>
				{triggerContent}
			</div>
			<motion.div
				initial="hidden"
				variants={VARIANTS}
				animate={isOpen ? 'visible' : 'hidden'}
				className={clsx(styles.content, classNames?.content)}
			>
				{content}
			</motion.div>
		</div>
	);
};
